/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { UsernameService } from '../../services/wealthlane-identity-services/services/UsernameService';

const usePostChangeUsername = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<any, unknown, any, unknown> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: { username: string }) => {
      return await handleRequest(
        UsernameService.postApiIdentityApiAppUsernameChangeUsername(payload)
      );
    },
    {
      onSuccess: async (response) => {
        if (response != null) {
          toast.success(<ToastComponent label='Success' message='Username updated.' />);
          await queryClient.refetchQueries('getParticipantAndLogin');
          await queryClient.refetchQueries('getMyProfile');
          closeModal();
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostChangeUsername;
